<template>
  <div>
    <span
      class="icon icon-smartphone text-icon"
      :class="{
        icon_warning: !isConnected,
        'icon_danger text-danger': isCourseClosedWrong,
        icon_primary: isConnected && !isCourseClosedWrong
      }"
    >
      <template v-if="isCourseClosedWrong">
        {{ error.text }}
      </template>
      <template v-else-if="isConnected"
        >{{ $t('src/components/connectedsmartphone.626')
        }}<span v-if="smartphoneData" class="ml-3 text-nowrap"
          >{{ smartphoneData.manufacturer }} {{ smartphoneData.model }}</span
        >
        <span v-else class="ml-3 text-nowrap">{{ $t('src/components/connectedsmartphone.9526') }}</span>
      </template>
      <template v-else>{{ $t('src/components/connectedsmartphone.1490') }}</template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ConnectedSmartphone',
  props: {
    appApiKey: {
      type: [String, null],
      required: false
    },
    smartphone: {
      type: String,
      required: false
    },
    error: {
      type: Object,
      required: false
    }
  },
  computed: {
    smartphoneData() {
      if (!this.smartphone) {
        return null
      }
      return JSON.parse(this.smartphone)
    },
    isConnected() {
      return Boolean(this.appApiKey) || Boolean(this.smartphone)
    },
    isCourseClosedWrong() {
      if (!this.error) {
        return false
      }
      return this.error.isClosedWrong
    }
  }
}
</script>
